import Cookies from "js-cookie";

export type CookieAttributes = Cookies.CookieAttributes;
export { Cookies };
export default Cookies;
